<template>
  
  <div class="group l_min-footspace" ref="sectionsGroup" data-id="sectionsGroup">
  
    <p>
      Editing Section <span v-html="builder.section"></span> of <span v-html="builder.sectionMax"></span>
    </p>
    
    <hr style="margin: 0;">
  </div>
  
  <component
    :is="comps.Size"
    :key="sectionComponentKey">
  </component>
  
  <component
    :is="comps.Interior"
    :key="sectionComponentKey">
  </component>
  
</template>

<script setup>
  
import { computed } from 'vue'

import Size from "@/components/builder/products/wardrobes/walkin/Size.vue";
import Interior from "@/components/builder/products/wardrobes/walkin/Interior.vue";

const comps = {
  Size,
  Interior
};

const props = defineProps([])

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const sectionComponentKey = computed(() => {
  return 'Section' + builder.section;
})
</script>